import React, { useState, useEffect, useRef } from 'react';
import styles from './LoanCalculatorTeaser.scss';
import ButtonRound from '../ButtonRound';
import Formatter from './Formatter';
import Calculator, { ICalcParams } from './Calculator';
import Config from '../../utils/Config';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LoanTextTeaser from './LoanTextTeaser';

export interface ILoanCalculatorTeaserProps {
    id: string;
    price: number;
    stampDuty?: number;
    notarialCosts?: number;
    landRegisterCosts?: number;
    findersFee?: number;
}

const LoanCalculatorTeaser: React.FC<React.PropsWithChildren<ILoanCalculatorTeaserProps>> = ({
    id,
    price = null,
    stampDuty = null,
    notarialCosts = null,
    landRegisterCosts = null,
    findersFee = null,
}) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    const calc = new Calculator(price, null, { stampDuty, notarialCosts, landRegisterCosts, findersFee });

    return <LoanTextTeaser />

    return (
        <div className={styles.loanCalculatorTeaser + ' ' + (isOpen ? styles.open : '')}>
            <h1>Finanzierung</h1>
            <h6>So viel Immobilie kann ich mir leisten:</h6>
            <div className={styles.teaser}>
                <div className={styles.value}>{Formatter.getEuroString(Math.round(calc.getMonatsrate()))}</div>
                <div className={styles.details}>
                    <div className={styles.fold} onClick={toggleOpen}>
                        Geschätzte Monatsrate
                        <KeyboardArrowDownIcon />
                    </div>
                    <div className={styles.table}>
                        <dl>
                            <dt>Kaufpreis</dt>
                            <dd>{Formatter.getEuroString(price)}</dd>
                        </dl>
                        <hr />
                        <dl>
                            <dt>+ Kaufnebenkosten</dt>
                            <dd>{Formatter.getEuroString(calc.getKaufnebenkostenValue())}</dd>
                            <dt>{'\u2212'} Eigenkapital</dt>
                            <dd>{Formatter.getEuroString(calc.getEigenkapital())}</dd>
                            <dt>= Nettodarlehen</dt>
                            <dd>{Formatter.getEuroString(calc.getNettodarlehen())}</dd>
                        </dl>
                        <hr />
                        <dl>
                            <dt>Monatsrate ca.</dt>
                            <dd>{Formatter.getEuroString(Math.round(calc.getMonatsrate()))}</dd>
                        </dl>
                    </div>
                    <p className={styles.annotations}>
                        Basierend auf {calc.getSollzinsbindung()} Jahren Sollzinsbindung / {Formatter.getNumberString(calc.getTilgungsrate())}% anfängliche
                        Tilgung / Effektivzins {Formatter.getNumberString(calc.getEffektivzins())}
                        {'\u00A0'}%
                    </p>
                </div>
            </div>
            <ButtonRound variant="outlined" className={styles.buttonCalculate} href={`/${Config.get('loanCalculatorRoute')}/${id}`}>
                Persönliche Rate berechnen <NavigateNextIcon />
            </ButtonRound>
        </div>
    );
};

export default LoanCalculatorTeaser;
